
import $ from 'jquery'
import { setToken } from '~/utils/auth'
export default {
  name: 'Login',
  head() {
    return {
      title: '客户管理系统 - 登录',
      meta: [
        {
          name: 'keywords',
          content: '客户管理系统',
        },
        {
          name: 'description',
          content: '客户管理系统',
        },
      ],
    }
  },
  data() {
    return {
      wxcode: 'https://api.baokuanxia.com/upload/Wxlogin/4cf3e53fa930edf36251bb865c357ec6.png',
      loginForm: {},
      wxtoken: '',
      showwxcode: false,
      isWxCodeExp: false,
      checkwxovertime: null,
      newPhoneVisible: false,
      user_token: '',
      phoneForm: { phone: '', code: '' },
      senBtn: false,
      isphonecode: false,
      sen: 60,
      isAdmin: false
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.getWxQrcode()
  },
  methods: {
    checkLoginInput1() {
      this.phoneForm.phone = this.phoneForm.phone.replace(/[^\d\s]/g, '')
      this.phoneForm.code = this.phoneForm.code.replace(/[^\d.]/g, '')
      if (this.phoneForm.phone > 13) {
        this.phoneForm.phone = this.phoneForm.phone.substring(0, 13)
      }

    },
    bindPhone() {

      let phone = this.phoneForm.phone
      if (!/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(this.phoneForm.phone)) {
        phone = this.phoneForm.phone.replace(/\s/g, '') // 判断是否有空格，有就删除
      }
      this.$bus.$emit('showLoading')
      this.$loginApi
        .bindPhone(this.user_token, phone, this.phoneForm.code)
        .then((res) => {
          this.$bus.$emit('hideLoading')
          if (res.code === 200) {

            if (res.data.status === 1) {
              setToken(this, this.user_token)

              this.$modal.msgSuccess(res.message)
              setTimeout(function () {
                window.location.href = '/'
              }, 1500)
            } else {
              this.newPhoneVisible = false
              this.isAdmin = true
              this.getWxQrcode()
            }


          } else {
            return this.$modal.msgError(res.message)
          }
        })
    },
    handlerPhone1(val) {
      if (val.length <= 13) {
        if (val.length > 3 && val.length < 7) {
          val = val.replace(/\D/g, '').replace(/(\d{3})(?=\d)/g, '$1 ')
        } else if (val.length >= 7 && val.length < 11) {
          val = val
            .replace(/\s/g, '-')
            .replace(/[^\d]/g, ' ')
            .replace(/(\d{4})(?=\d)/g, '$1 ')
        } else if (val.length >= 11) {
          val = val
            .replace(/\s/g, '-')
            .replace(/[^\d]/g, ' ')
            .replace(/(\d{3})(\d{4})(\d{4})/, '$1 $2 $3')
        }
        this.$set(this.phoneForm, 'phone', val)
      }

    },
    get_code2() {
      const _this = this
      if (this.isphonecode) return false
      if (this.phoneForm.phone === '') {
        return this.$modal.msgError('请输入手机号')
      }
      this.isphonecode = true
      this.$bus.$emit('showLoading')
      let name
      if (!/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(this.phoneForm.phone)) {
        name = this.phoneForm.phone.replace(/\s/g, '') // 判断是否有空格，有就删除
      }
      this.$loginApi
        .sendCode(name, this.user_token)
        .then((res) => {
          this.$bus.$emit('hideLoading')
          if (res.code === 200) {
            this.senBtn = true
            $('.phonecode').html(this.sen + '秒后，可以继续获取')
            this.isphonecode = true
            setTimeout(function () {
              _this.daojishi()
            }, 1000)

          } else if (res.code === 203) {

            setToken(this, this.user_token)

            this.$modal.msgSuccess(res.message)
            setTimeout(function () {
              location.reload(true)
            }, 1000)
          } else {
            this.isphonecode = false
            this.$modal.msgError(res.message)
          }
        })
    },
    daojishi() {
      const _this = this
      this.sen--
      if (this.sen >= 1) {
        this.senBtn = true
        $('.phonecode').html(this.sen + '秒后，可以继续获取')
        setTimeout(function () {
          _this.daojishi()
        }, 1000)
      } else {
        this.senBtn = false
        this.sen = 60
        this.isphonecode = false
        $('.phonecode').html('获取手机验证码')
      }
    },
    getWxQrcode() {
      this.$loginApi.wxQrcodeTicket('wxlogin').then((res) => {
        if (res.code === 200) {
          this.wxtoken = res.data.token
          this.wxcode = res.data.qrcode
          this.showwxcode = true
          this.isWxCodeExp = false

          if (this.isAdmin) {
            this.checkwxovertime = setInterval(() => {
              this.checkAdminWx()
            }, 2000)
          } else {
            this.checkwxovertime = setInterval(() => {
              this.checkWx()
            }, 2000)
          }

        } else {
          this.$modal.msgError(res.message)
        }
      })
    },
    checkWx() {
      this.$loginApi.checkWxLogintokenByTicket(this.wxtoken).then((res) => {
        if (res.code === 200) {
          if (res.data.is_phone === 1) {
            clearInterval(this.checkwxovertime)
            if (res.data.status === 1) {
              setToken(this, res.data.user_token)
              this.$modal.msgSuccess('登录成功')
              setTimeout(() => {
                window.location.href = '/'
              }, 1500)
            } else {
              this.user_token = res.data.user_token
              this.isAdmin = true
              this.getWxQrcode()
            }

          } else {
            clearInterval(this.checkwxovertime)
            this.newPhoneVisible = true
            this.user_token = res.data.user_token
          }
        } else if (res.code === 202) {
          clearInterval(this.checkwxovertime)
          this.isWxCodeExp = true
        }
      })
    },
    checkAdminWx() {
      this.$loginApi.checkWxLogintokenAdminByTicket(this.wxtoken, this.user_token).then((res) => {
        if (res.code === 200) {
          clearInterval(this.checkwxovertime)
          setToken(this, this.user_token)
          this.$modal.msgSuccess('登录成功')
          setTimeout(() => {
            window.location.href = '/'
          }, 1500)
        } else if (res.code === 202) {
          clearInterval(this.checkwxovertime)
          this.isWxCodeExp = true
        }
      })
    },
  },
}
